import { createFileRoute } from '@tanstack/react-router'
import { PartsDatabase } from 'pages/partsDatabase/PartsDatabase'

function RouteComponent() {
  const { orgId, siteId } = Route.useSearch()

  return <PartsDatabase orgId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/parts/')({
  component: RouteComponent,
  staticData: {
    title: 'Parts',
  },
})
